import { Paper, Box, Typography, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  title?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  bodyPadding?: number | string;
  noBodyPadding?: boolean;
  sx?: SxProps<Theme>;
}

export function Card({ title, action, children, bodyPadding = 1.5, noBodyPadding, sx }: Props) {
  return (
    <Paper variant="outlined" sx={[{ borderRadius: 2 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}>
      {(title || action) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            px: { xs: 2, sm: 3 },
            py: { xs: 1.75, sm: 2 },
            borderBottom: 1,
            borderColor: 'divider',
          }}>
          {typeof title === 'string' ? (
            <Typography variant="subtitle1" sx={{ fontWeight: 'fontWeightMedium' }}>
              {title}
            </Typography>
          ) : (
            title
          )}
          {action}
        </Box>
      )}
      <Box sx={{ p: noBodyPadding ? 0 : bodyPadding }}>{children}</Box>
    </Paper>
  );
}
